import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sanitizeRegistrationNumber } from '@repo/domain-service';
import { Input } from '@repo/ui';
import { getLabels } from '../../labels';
export default function VehicleRegistrationInput({ value, onChange, onBlur, testId, disabled }) {
    const handleChange = (newValue) => {
        const sanitized = sanitizeRegistrationNumber(newValue);
        onChange(sanitized);
    };
    return (_jsxs("div", { className: "relative", children: [_jsx("div", { className: "bg-vehicle-accent border-vehicle-accent absolute top-0 left-0 z-1 h-full w-4.5 rounded-tl-xl rounded-bl-xl border" }), _jsx(Input, { placeholder: getLabels().vehicle.registration_number_placeholder, value: value, onChange: handleChange, onBlur: onBlur, maxLength: 10, pattern: "[a-zA-Z0-9 ]*", className: "pl-7", disabled: disabled, testId: testId })] }));
}
